import {useDispatch, useSelector} from 'react-redux';
import {changeSuccessModalState} from '../../store/actionCreators';
import {StoreState} from '../../type.d';
import Modal from 'react-bootstrap/Modal';
import checkmark from '../../../images/checkmark.svg';
import * as Styled from './SuccessModalStyles';

const SuccessModal = () => {
  const dispatch = useDispatch();

  const {successModal} = useSelector( (rootReducer:StoreState) => rootReducer.reducer);

  const ChangeSuccessModalState = () => dispatch(changeSuccessModalState());

  return (
    <Modal 
        show={successModal} 
        onHide={()=>ChangeSuccessModalState()} 
        animation={false}
        centered
        size='sm'
        contentClassName='custom-content'
        dialogClassName='custom-dialog'
      >
        <Styled.StyledModalBody >
          <Styled.Container>
            <img src={checkmark} alt="Chekmark"/>
            <Styled.StyledParagraph>
              Successfully connected with <br/>  
              [Slack]. <br/>
              Ready to Search!
            </Styled.StyledParagraph>
          </Styled.Container>
        </Styled.StyledModalBody>
      </Modal>
  );
}

export default SuccessModal;